import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/patterns/Icon'
import Tooltip from 'components/patterns/Tooltip'
import { classNames } from 'utils/utils'
import withStyle from './HoverableInfoIcon.style.js'

const HoverableInfoIcon = ({
  overlayClassName,
  className,
  tooltip,
  tooltipPosition,
  icon,
  overlayStyle,
  align,
}) => (
  <Tooltip
    placement={tooltipPosition}
    className={classNames(className, 'hoverable-info-icon')}
    title={tooltip}
    overlayClassName={overlayClassName}
    overlayStyle={overlayStyle}
    align={align}
  >
    <Icon icon={icon} size={14} fill="outlined" />
  </Tooltip>
)

HoverableInfoIcon.defaultProps = {
  icon: 'question_mark_tooltip',
  tooltipPosition: 'top',
}

HoverableInfoIcon.propTypes = {
  /** Make sure to comment */
  /** Classname */
  className: PropTypes.string,
  /** Content of tooltip displayed over icon */
  tooltip: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.func,
  ]),
  /** where you want the tooltip to show up in relationship to the icon */
  tooltipPosition: PropTypes.oneOf([
    'top',
    'right',
    'left',
    'bottom',
    'topRight',
    'bottomLeft',
  ]),
  /** preset position boolean */
  topRight: PropTypes.bool,
  /** preset position boolean */
  centerLeft: PropTypes.bool,
  /** override icon type */
  icon: PropTypes.string,
  /** add className to the tooltip content */
  overlayClassName: PropTypes.string,
  /** add overlay styles to tooltip */
  overlayStyle: PropTypes.object,
  /** rc-align override, e.g. { offset: [x, y] } to nudge popup position */
  align: PropTypes.object,
}

export default withStyle(HoverableInfoIcon)
